import { FormContainerProps } from 'components/Forms/FormContainer';
import { City } from 'services/api';
import { AutocompleteOption } from 'src/components/Autocomplete/types';

import { LocationFormValues } from './validation';

export interface ILocationFormProps
  extends Pick<
    FormContainerProps<LocationFormValues>,
    'onSubmit' | 'initialValues' | 'buttons'
  > {
  cities: City[];
  locations: AutocompleteOption[];
  searchQuery: string;
  onQuery: (value: string) => void;
  loadingLocations: boolean;
  onSelectAddress: (value: AutocompleteOption) => void;
}

export enum FieldLabel {
  Name = 'Location name *',
  Street = 'Address *',
  Unit = 'Floor *',
  City = 'City *',
  Zipcode = 'Zipcode *',
  Building = 'Building',
  Address_Other = 'Address Details',
  Instruction = 'Delivery Instructions',
  SearchLocation = 'Search a Location'
}
